module.exports = "pegasus_template/assets/pexels-photo-3.png";